import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApi } from "../use-api";

interface DeleteArgusScheduleInput {
  scheduleId: string;
}

export function useDeleteArgusSchedule() {
  const queryClient = useQueryClient();
  const { callApi } = useApi<void>();

  return useMutation({
    mutationFn: async (input: DeleteArgusScheduleInput) => {
      await callApi(`/client/argus/schedules/${input.scheduleId}`, {
        method: "DELETE",
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        predicate: (query) =>
          typeof query.queryKey[0] === "string" &&
          query.queryKey[0].startsWith("/client/argus/schedules"),
      });
    },
  });
}
